import { FC } from "react";
import { useTranslation } from "react-i18next";

import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";

import Actions from "../Certificate/Actions";
import TableComponent from "../TableComponent";
import { BundleWithActions } from "../../features/compliance/bundles";

import "./index.scss";

interface BundleListProps {
  bundles: BundleWithActions[];
}

const BundleList: FC<BundleListProps> = ({ bundles }) => {
  const { t } = useTranslation();

  const header = [
    { title: t("bundle_list.id"), style: { width: "5%" } },
    { title: t("bundle_list.name"), style: { width: "15%" } },
    { title: t("bundle_list.description"), style: { width: "25%" } },
    { title: t("bundle_list.includes"), style: { width: "30%" } },
    { title: t("bundle_list.price"), style: { width: "15%" } },
    { title: t("bundle_list.actions"), style: { width: "15%" } },
  ];
  return (
    <TableComponent
      pagination
      pageSize={25}
      items={bundles}
      search={["name"]}
      header={header}
      renderChildren={(bundle: BundleWithActions) => (
        <TableRow key={bundle.id}>
          <TableCell>{bundle.id}</TableCell>
          <TableCell>{bundle.name}</TableCell>
          <TableCell>{bundle.description}</TableCell>
          <TableCell>
            <div className="courses" title={bundle.courses?.map((c) => c.shortname || c).join(", ")}>
              {bundle.courses?.map((course: any) => (
                <span key={course.id || course}>{course.shortname || course}</span>
              ))}
            </div>
          </TableCell>
          <TableCell>{bundle.price ?? t("bundle_list.free")}</TableCell>
          <TableCell style={{ width: "5%" }}>
            <Actions bundle={bundle} />
          </TableCell>
        </TableRow>
      )}
    />
  );
};

export default BundleList;
